import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient as AngularHttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@ispm-client/modules/core/services/http-client';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import {cloneDeep} from 'lodash';
const defaultOptions = {
    withCredentials: true
};

/**
 * HttpService for ISPM web server
 */
@Injectable()
export class IspmHttpClient implements HttpClient {
    private ispmWebserverEndpoint$: Subject<string> = new ReplaySubject(1);
    public http: AngularHttpClient;

  constructor(protected isgHttp: HttpInterceptorService) {
    this.getIspmWebServerEndpoint();
  }

  private getIspmWebServerEndpoint() {
    this.isgHttp
      .get('/endpoints/ispmwebserver')
      // .catch(error => {
      //   console.error(`error getting ispmwebserver url : ${JSON.stringify(error)}`);
      //   this.ispmWebserverEndpoint$.error(error);
      //   return Observable.throw(error);
      // })
      .subscribe(
                res => this.ispmWebserverEndpoint$.next(res.json().endpoint)
      );
  }

    public get<T = any>(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }, useOriginalOrg?: boolean): Observable<T> {
        return this.ispmWebserverEndpointRetry$().pipe(
            switchMap((ispmWeb) =>{
                return this.isgHttp.get(`${ispmWeb}/${url}`, params, toggleLoader, headers, {
                    ...defaultOptions, ...options}, true, false, useOriginalOrg)
            } ),
            map((res)=>{
                return res.json()
            }
            )
        );
    }

    public getFile(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }): Observable<any> {
        return this.ispmWebserverEndpointRetry$().pipe(
            switchMap(ispmWeb => this.isgHttp.getFile(`${ispmWeb}/${url}`, params, toggleLoader, headers, { ...defaultOptions, ...options}))
      );
    }

    public post<T = any>(url, body, toggleLoader?: boolean, headers?: { [prop: string]: string }, params?: { [prop: string]: string }, options?: { [prop: string]: any }, useOriginalOrg?:boolean): Observable<T> {
      const originBody = cloneDeep(body);
      return this.ispmWebserverEndpointRetry$().pipe(
          switchMap(ispmWeb => this.isgHttp.post(`${ispmWeb}/${url}`, originBody, toggleLoader, headers, params, {...defaultOptions, ...options}, false, useOriginalOrg)),
          map(res => res.json())
      );
    }

    public put<T = any>(url, body, toggleLoader?: boolean, headers?: { [prop: string]: string }, params?: { [prop: string]: string }, options?: { [prop: string]: string }): Observable<T> {
        return this.ispmWebserverEndpointRetry$().pipe(
            switchMap(ispmWeb => this.isgHttp.put(`${ispmWeb}/${url}`, body, toggleLoader, headers, params, { ...defaultOptions, ...options})),
            map(res => res.json())
        );
    }

    public delete(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }): any {
        return this.ispmWebserverEndpointRetry$().pipe(
            switchMap(ispmWeb => this.isgHttp.delete(`${ispmWeb}/${url}`, params, toggleLoader, headers, { ...defaultOptions, ...options})),
            map(res => res)
        );
    }

    private ispmWebserverEndpointRetry$(): Observable<string> {
        return this.ispmWebserverEndpoint$.catch(error => {
            this.getIspmWebServerEndpoint();
            return this.ispmWebserverEndpoint$;
        });
    }
}
